<template>
  <nav aria-label="breadcrumb">
    <ul class="breadcrumb">
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        :class="['breadcrumb-item', {'active': !breadcrumb.link}]" :aria-current="breadcrumb.link ? false : 'page'">
        <router-link tag="a" :to="breadPath(breadcrumbList[idx])" v-if="breadcrumbList.length > idx+1">{{ breadcrumb.name }}</router-link>{{ breadcrumbList.length <= idx+1 ? breadcrumb.name : '' }}
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data() {
    return {
      breadcrumbList: []
    }
  },
  mounted() {
    this.updateList()
    this.$root.$on('update-breadcrumb', this.updateBreadcrumb)
  },
  watch: {
    /* This watches the routes and updates the breadcrumb list accordingly, but eslint hates it. */
    // eslint-disable-next-line
    '$route'() {
      this.updateList()
    },
    /* Placeholder can arrive after mount (e.g. draft name fetched async on a direct/refreshed page load) */
    // eslint-disable-next-line
    '$store.state.placeholder'() {
      this.updateList()
    }
  },
  methods: {
    /* Getting breadcrumb list after switching out 'Placeholder' and 'Create'/'Add' text if necessary */
    updateList() {
      this.$nextTick(() => {
        const theUpdateList = [...this.$route.meta.breadcrumb]
        const placeholderPosition = this.$route.meta.breadcrumb.findIndex(bread => bread.name === 'Placeholder')
        const editPosition = this.$route.meta.breadcrumb.findIndex(bread => bread.name.includes('Create') || bread.name.includes('Add'))
        const membersPosition = this.$route.meta.breadcrumb.findIndex(bread => bread.name.includes('Members'))
        /* If route breadcrumb has 'Placeholder' in it and there's associated data to fill it */
        if (placeholderPosition !== -1 && (this.$route.params.placeholder || this.$store.state.placeholder)) {
          theUpdateList[placeholderPosition] = Object.assign({}, theUpdateList[placeholderPosition], { name: this.$route.params.placeholder || this.$store.state.placeholder })
        }
        if (membersPosition !== -1 && this.$isAdmin) {
          theUpdateList[membersPosition] = Object.assign({}, theUpdateList[membersPosition], { name: 'Members', link: 'admin-members' })
        }
        /* If route breadcrumb has 'Create' or 'Add' in it and there's an 'edit' prop */
        if (editPosition !== -1 && this.$route.params.edit) {
          theUpdateList[editPosition] = Object.assign({}, theUpdateList[editPosition], { name: theUpdateList[editPosition].name.replace('Create', 'Edit').replace('Add', 'Edit') })
        }
        this.breadcrumbList = theUpdateList
      })
    },
    breadPath(breadItem) {
      /* Get slug (can be expanded to other params later) if told to by router - couldn't find a way to get this in the router file */
      let output = ''
      if (breadItem.routeName) {
        output = { name: breadItem.routeName, params: { draftId: this.$route.params.draftId } }
      } else if (breadItem.params) {
        output = { name: breadItem.name, params: { slug: this.$route.params.slug } }
      } else {
        output = `/${breadItem.link}`
      }
      return output
    },
    updateBreadcrumb(updated) {
      const idx = this.breadcrumbList.findIndex(b => b.name === updated.name)
      if (idx !== -1) {
        this.$set(this.breadcrumbList, idx, { ...this.breadcrumbList[idx], link: updated.link, name: updated.name })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue